/**
 * @file    MainErrorFallback.css - Styles the `MainErrorFallback` component in @/components/erros/main.jsx
 *
 *          Sets the overflow of the error-message to auto in case of long/large error messages
 *
 * @author  Ruslan Kain <ruslan@distributive.network>
 * @date    Aug. 2024
 */
 
.error-message {
  max-height: 200px;
  overflow: auto; 
}
